import React, { useState, useEffect } from 'react';
import NavBarElement from './NavBarElement';

export default function NavBarDesktop({ handleClick }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Hide images when scrolled more than 50px
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* Pivara Logo */}
      <img
        src='/images/pivara_logo.png'
        className={`w-20 h-20 fixed top-1 right-28 sm:right-28 md:left-5 z-40 transition-opacity duration-300 ${
          isScrolled ? 'opacity-0' : 'opacity-100'
        }`}
        alt='pivara_logo'
      ></img>

      {/* Svesrbija Logo */}
      <a
        href='https://www.svesrbija.rs'
        target='_blank'
        rel='noopener noreferrer'
      >
        <img
          src='/images/svesrbija.PNG'
          className={`w-20 h-20 fixed top-1 right-5 z-40 transition-opacity duration-300 ${
            isScrolled ? 'opacity-0' : 'opacity-100'
          }`}
          alt='svesrbija_logo'
        />
      </a>

      {/* Navigation Bar */}
      <nav
        className='
        hidden md:flex fixed w-full bg-black bg-opacity-60 z-30
        items-center justify-center py-4 px-4 text-lg text-white
      '
      >
        <ul className='flex space-x-8 text-2xl'>
          <NavBarElement
            text={'ПОЧЕТНА'}
            path='/home'
            id='home'
            handleClick={handleClick}
          />
          <NavBarElement
            text={'ПИВА'}
            path='#'
            id='beers'
            handleClick={handleClick}
          />
          <NavBarElement
            text={'НАША ПРИЧА'}
            path='#'
            id='our-story'
            handleClick={handleClick}
          />
          <NavBarElement
            text={'ПРОДАВНИЦА'}
            path='/prodaja'
            id='locations'
            handleClick={handleClick}
            customStyle='border-2 border-solid border-yellow-500 hover:text-yellow-500'
          />
        </ul>
      </nav>
    </>
  );
}
